const AchievementDescription = () => {
  return (
    <section className="achievement-text">
      <h2 className="title-font pink-text h2-tag">Achievement</h2>
      <p className="white-text p-tag">
<b>School Level Championship (2022)</b>
<br/>
<br/>
Maine apne school ke volleyball team ke saath 2022 mein school level volleyball championship mein participate kiya aur humne sabhi mukaable ko harakar school level ka championship jeeta. Is tournament mein humne apne teamwork aur dedication ka pradarshan kiya aur har mukaable mein safalata prapt ki.

Is vijay ne mujhe aur mere team ko ek mazboot foundation diya aur humein agle level par badhne ka sahas aur vishwas diya. Yeh safar humein ek dusre ke saath jyada jude huye aur ek sath kam karne ka mahatv samjha.
<br/>
<br/>
<b>Zonal Level Runner-Up to Champion: A Journey of Growth (2023-2024)</b>
<br/>
<br/>
Mujhe garv hai ki hum 2023 mein zonal level volleyball tournament mein runner-up position hasil kiya, lekin humne haar ko ek nayi sikh ke roop mein dekha aur usse apne liye ek naya uddeshya banaya. Is safar ne humein mehnat aur sahyog ki mahatv ko samjha aur humein 2024 mein zonal level ka championship jeetne ka avasar diya.

Yeh safar ek anubhuti bhara raha, jismein humne saath milkar kathin parishram kiya aur apne khel mein pragati ki. Har kadam par humne naye raaste seekhe aur apne khel ko behtar banane ke liye mehnat ki.
      </p>
    </section>
  );
};

export default AchievementDescription;
